/**
 * 全局路由权限中间件
 * @author NUXT专家
 * @created 2024/12/xx
 */

export default defineNuxtRouteMiddleware((to, from) => {
  // 只在客户端执行
  if (process.client) {
    // 检查路由是否需要登录
    if (to.meta?.isLogin) {
      try {
        // 获取全局 store 和 token cookie
        const globalStore = useGlobalStore()
        const token = useCookie('access_token')
        // 如果 globalStore 还没有初始化，但是有 token，则先设置登录状态
        if (!globalStore.isLogin && token.value) {
          globalStore.setIsLogin(true)
          globalStore.getUser()
        }

        // 检查登录状态（store 或 token 任一存在即可）
        if (!globalStore.isLogin && !token.value) {
          const redirectUrl = `/login?redirect=${encodeURIComponent(to.fullPath)}`
          if (to.fullPath.indexOf('/login') == -1) {
            return navigateTo(redirectUrl)
          }
        }
      } catch (error) {
        // 出错时也跳转到登录页
        return navigateTo('/login')
      }
    }
  }
})
